import { render } from "./CalculatorSkill.vue?vue&type=template&id=4e2be268&ts=true"
import script from "./CalculatorSkill.vue?vue&type=script&lang=ts"
export * from "./CalculatorSkill.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__